import type { DesignTemplateColor, ToLocaleStringCoverDataItem } from './schemas'

// 표지 편집기가 고르게 하는 색. 서버 색 중 흑백(BW)은 선택지에 없다
export const DESIGN_TEMPLATE_COLOR_CHIPS = [
  'WHITE',
  'SKY',
  'BLUE_GREEN',
  'GREEN',
  'PINK',
  'ORANGE',
  'YELLOW',
] as const satisfies readonly DesignTemplateColor[]
export type DesignTemplateColorChip = (typeof DESIGN_TEMPLATE_COLOR_CHIPS)[number]

export const DESIGN_TEMPLATE_COLOR_KO = {
  WHITE: '화이트',
  SKY: '스카이',
  BLUE_GREEN: '블루그린',
  GREEN: '그린',
  PINK: '핑크',
  ORANGE: '오렌지',
  YELLOW: '옐로우',
} as const satisfies Record<DesignTemplateColorChip, string>

// 교재 표지 색(Figma 기준). 화면 스타일 토큰이 아니라 표지 템플릿의 색 값이다
export const DESIGN_TEMPLATE_COLOR_HEX = {
  WHITE: '#FFFFFF',
  SKY: '#37BEF0',
  BLUE_GREEN: '#00ADA9',
  GREEN: '#43B149',
  PINK: '#E098C1',
  ORANGE: '#EE782C',
  YELLOW: '#FCC80E',
} as const satisfies Record<DesignTemplateColorChip, string>

// 표지 고르기 화면의 분류 탭. 서버 categories 는 DB 자유 문자열이고 이 목록은 화면이 보여 줄 분류다
export const DESIGN_TEMPLATE_CATEGORIES = [
  '그래픽',
  '일러스트',
  '심플한',
  '동물',
  '수학기호',
  '귀여운',
  '감성적인',
  '전문적인',
] as const
export type DesignTemplateCategory = (typeof DESIGN_TEMPLATE_CATEGORIES)[number]

// 판매가 칸이 없는 교재 표지에 채우는 기본 판매가. 쓰는 쪽이 고치므로 복제해서 넣는다
export const DEFAULT_SALES_PRICE_COVER_DATA_ITEM: ToLocaleStringCoverDataItem = {
  id: 'salesPrice',
  type: 'TO_LOCALE_STRING',
  order: 10,
  props: {
    readOnly: true,
    prefixValue: '정가: ',
    suffixValue: '원',
    defaultValue: 10000,
    renderProps: {
      x: 2,
      y: 767,
      height: 12,
      fontSize: 10,
      maxWidth: 100,
      position: 'bottom-right',
      fontColor: '#111',
      fontFamily: 'Pretendard-Medium',
      transform: 'rotate(90 52 773)',
    },
  },
}
